export default __webpack_public_path__ + "static/media/ksivalue_mobile@2x.f8dd1055.jpg";